{
  "version": 1,
  "asset_id": "fb831bcc-4b5d-4884-b268-bbf486acf69e",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/fb831bcc-4b5d-4884-b268-bbf486acf69e/sleeve-amateur-2.png",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/fb831bcc-4b5d-4884-b268-bbf486acf69e/sleeve-amateur-2.png",
  "original_filename": "sleeve-amateur-2.png",
  "size": 1391095,
  "content_type": "image/png",
  "created_at": "2026-07-14T23:06:44Z"
}
